<template>
  <div class="base-dialog-title">
    <div class="base-dialog-title__left">
      <div v-if="$slots.default">
        <slot />
      </div>
      <div v-else>
        {{ title }}
      </div>
    </div>
    <div v-if="showFullScreen" class="base-dialog-title__right">
      <button class="base-dialog-title__full-screen" @click="toggleFullScreen">
        <i v-if="isFullScreen" class="el-icon-copy-document" />
        <i v-else class="el-icon-full-screen" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDialgTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    showFullScreen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isFullScreen: false
    }
  },
  methods: {
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen
      this.$emit('toggle', this.isFullScreen)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-dialog-title {
  flex: 1;
  display: flex;
  align-items: center;
  height: 54px;
  &__left {
    font-size: 18px;
    color: #111;
    position: relative;
  }
  &__right {
    margin-left: auto;
    margin-right: 32px;
    .base-dialog-title__full-screen {
      padding: 0;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
    }
    .el-icon-full-screen, .el-icon-copy-document {
      font-size: 24px;
			color: #999;
    }
  }
}
</style>
